/**
 * Session ID Generation Utility
 * Centralized session ID generation used across logging, analytics, and other services
 * 
 * @returns {string} Unique session ID in format: session_{timestamp}_{random}
 */
export function generateSessionId() {
  return `session_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
}

